var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconEyedrop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.79663 21.2033V16.1663L11.6629 7.3L10.2069 5.9L11.9499 4.213L13.8499 6.113L16.8004 3.1505C16.9077 3.04334 17.0358 2.96075 17.1846 2.90275C17.3336 2.84475 17.4887 2.81775 17.6499 2.82175C17.807 2.82175 17.958 2.85175 18.1026 2.91175C18.2471 2.97175 18.3794 3.05534 18.4994 3.1625L20.8374 5.5005C20.9445 5.6205 21.0281 5.75275 21.0881 5.89725C21.1481 6.04192 21.1781 6.19284 21.1781 6.35C21.1821 6.51117 21.1551 6.66625 21.0971 6.81525C21.0391 6.96409 20.9565 7.09217 20.8494 7.1995L17.9059 10.131L19.8059 12.081L18.0999 13.787L16.6999 12.337L7.83363 21.2033H2.79663ZM5.07163 18.9283H6.91988L15.1481 10.65L13.3499 8.85175L5.07163 17.08V18.9283ZM16.2646 8.68425L18.6049 6.35L17.6499 5.395L15.3156 7.73525L16.2646 8.68425Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEyedrop);
export default __webpack_public_path__ + "static/media/icon-eyedrop.e337d5d64ef8952d89fbdd9d83eaf246.svg";
export { ForwardRef as ReactComponent };